module.exports = __webpack_public_path__ + "static/img/mobile-devices-blue-hue-original.446182ae.jpg";